import {Controller} from "stimulus"
import DOMUtils from "../utils/DOMUtils";

export default class extends Controller {

    static targets = [
        "regionSelect",
        "citySelect"
    ]

    initialize() {
        this.$originalCitySelect = DOMUtils.cloneElement(this.$citySelect)
    }

    regionChange(e){
        const region = this.$regionSelect.value
        const $citiesOptions = [...this.$originalCitySelect.querySelectorAll(`option[data-region='${region}']`)]
        let citiesOptionsHTML = ""
        if ( !$citiesOptions.length ) {
            citiesOptionsHTML = DOMUtils.getHTML(this.$originalCitySelect)
        } else {
            $citiesOptions.unshift(this.$originalCitySelect.querySelectorAll(`option`)[0])
            citiesOptionsHTML = DOMUtils.getListHTML($citiesOptions)
        }
        this.$citySelect.innerHTML = citiesOptionsHTML
    }

    get $citySelect() {
        return this.citySelectTarget
    }

    get $regionSelect() {
        return this.regionSelectTarget
    }


}